export const TEXTS_EMPLEO = {
  es_ES: new Map([
    ['unnenployment_precentage', 'Paro'],
    ['GeneroM', 'Masculino'],
    ['GeneroF', 'Femenino'],
    ['GeneroMdesempleo', 'Hombrees desempleados'],
    ['GeneroFdesempleo', 'Mujeres desempleadas'],
    ['Tasa', 'Tasa'],
    ['01', 'Enero'],
    ['02', 'Febrero'],
    ['03', 'Marzo'],
    ['04', 'Abril'],
    ['05', 'Mayo'],
    ['06', 'Junio'],
    ['07', 'Julio'],
    ['08', 'Agosto'],
    ['09', 'Septiembre'],
    ['10', 'Octubre'],
    ['11', 'Noviembre'],
    ['12', 'Diciembre'],
    ['Paro', 'Paro'],
  ]),
  ca_ES: new Map([
    ['unnenployment_precentage', 'Atur'],
    ['GeneroM', 'Masculí'],
    ['GeneroF', 'Femení'],
    ['GeneroMdesempleo', 'Homes desempleats'],
    ['GeneroFdesempleo', 'Dones desempleades'],
    ['Tasa', 'Taxa'],
    ['01', 'Gener'],
    ['02', 'Febrer'],
    ['03', 'Març'],
    ['04', 'Abril'],
    ['05', 'Maig'],
    ['06', 'Juny'],
    ['07', 'Juliol'],
    ['08', 'Agost'],
    ['09', 'Setembre'],
    ['10', 'Octubre'],
    ['11', 'Novembre'],
    ['12', 'Desembre'],
    ['Paro', 'Atur'],
  ]),
};
